import {
  CardContent,
  Typography,
  CardHeader,
  Separator,
  Avatar,
  Button,
  Card,
} from '@ui/components';
import { useTranslation } from 'react-i18next';
import { useCurrentUser } from '@shared/hooks';

export const SelectCompany = () => {
  const { user, setUserCompany } = useCurrentUser();
  const { t } = useTranslation();

  return (
    <main className="flex h-screen overflow-hidden bg-[url('../images/dimm.jpg')] bg-cover items-center justify-center p-8">
      <Card className="w-full lg:min-w-96 lg:w-auto">
        <CardHeader>
          <Typography variant="h300">{t('AUTH.SELECT_COMPANY')}</Typography>
        </CardHeader>

        <Separator />

        <CardContent className="flex flex-col gap-2 p-2">
          {user?.companies.map((company) => (
            <Button
              onClick={() => setUserCompany(company.id!)}
              className="justify-start flex gap-4"
              key={company.id}
              variant="ghost"
              size="large"
            >
              <Avatar fallback={company.name} />
              <div className="flex flex-col items-baseline">
                <Typography className="text-default max-w-48 truncate" variant="labelMediumMedium">
                  {company.name}
                </Typography>
                <Typography variant="labelSmallBook" className="text-weak">
                  {t(`AUTH.ROLE.${company.role}`)}
                </Typography>
              </div>
            </Button>
          ))}
        </CardContent>
      </Card>
    </main>
  );
};
